import { createContext, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const DialogContext = createContext();

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("useDialog must be used within a DialogProvider");
  }
  return context;
};

export const useDialogState = () => {
  const [dialogStack, setDialogStack] = useState([]);

  const openDialog = ({ title, content, callback, maxWidth = "lg", fullScreen = false }) => {
    const dialogId = uuidv4(); 

    const close = (result) => {
      setDialogStack((prev) => prev.filter((dialog) => dialog.id !== dialogId));
      if (callback) callback(result ?? {});
    };

    const dialog = {
      id: dialogId,
      title,
      content,
      callback,
      maxWidth,
      fullScreen,
      close,
    };

    setDialogStack((prev) => [...prev, dialog]);

    return { close };
  };

  const resetDialog = () => {
    setDialogStack([]);
  };

  return {
    dialogStack,
    openDialog,
    resetDialog
  };
};
